import { defineComponent, onMounted, ref } from 'vue';
import './index.less';
import { EN_MESSAGE_STATUS, IMessage, MessageService, EN_MESSAGE_LEVEL } from './message_service';

export const MessageCard = defineComponent({
  components: {},
  setup() {
    const message = ref<IMessage | undefined>();
    const visible = ref(false);

    const init = () => {
      const message = localStorage.getItem('do.message');
      if (message) {
        try {
          const msgObj: IMessage = JSON.parse(message);
          setMessage(msgObj);
        } catch {
          console.error(`invalid message: `, message);
        }
      }
      _polling();
    };

    onMounted(init);

    const setMessage = (msg: IMessage) => {
      const isEqual = _checkMsgEqual(msg, message.value);
      if (isEqual) {
        return;
      }
      _checkVisible(msg, message.value);
      message.value = msg;
      _saveMessage();
    };

    const clearMessage = () => {
      message.value = {
        level: EN_MESSAGE_LEVEL.INFO,
        content: '',
        status: EN_MESSAGE_STATUS.READ,
        timestamp: 10,
      };
      _checkVisible(message.value);
      _saveMessage();
    };

    const readMessage = () => {
      if (message.value) {
        message.value.status = EN_MESSAGE_STATUS.READ;
      }
      _checkVisible(message.value);
      _saveMessage();
    };

    const _saveMessage = (msg: IMessage | undefined = message.value) => {
      if (!msg) {
        window.localStorage.removeItem('do.message');
      } else {
        window.localStorage.setItem('do.message', JSON.stringify(msg));
      }
    };

    const _checkVisible = (curMsg?: IMessage, preMsg?: IMessage) => {
      if (!curMsg || curMsg.status === EN_MESSAGE_STATUS.READ) {
        visible.value = false;
        return;
      }
      if (!preMsg || preMsg.content !== curMsg.content) {
        visible.value = true;
        return;
      }
      visible.value = false;
    };

    const _checkMsgEqual = (curMsg?: IMessage, preMsg?: IMessage) => {
      if (!curMsg && !preMsg) {
        return true;
      }
      if (curMsg && preMsg && preMsg.content === curMsg.content) {
        return true;
      }
      return false;
    };

    const _polling = async () => {
      // 10s
      const time = 10 * 1000;
      setTimeout(() => {
        MessageService.getMessage()
          .then((msg) => {
            if (msg) {
              setMessage(msg);
            } else {
              clearMessage();
            }
          })
          .finally(() => {
            _polling();
          });
      }, time);
    };

    const iknow = () => {
      console.log('i know');
      readMessage();
    };

    return {
      visible,
      message,
      iknow,
    };
  },
  render() {
    return (
      <div>
        <a-card
          class={this.visible ? 'card card-show' : 'card card-hidden'}
          size="small"
          title={'发版通知'}
          extra={<a-button onClick={() => this.iknow()}>知道了</a-button>}
        >
          <p>
            则形用户您好，平台将于<span class="msg">{this.message?.content ?? ''}</span>
            ，升级期间请提前保存文件，感谢您的支持！
          </p>
        </a-card>
      </div>
    );
  },
});
